import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col } from 'antd';
import { keyBy, get, filter } from 'lodash';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import queryString from 'query-string';
// import InlineSVG from 'svg-inline-react';

import currency from 'utils/currency';
import helpers from 'utils/helpers';
import AddressCard from './AddressCard';
import ExpandButton from './ExpandButton';
import InfoBar from 'components/common/InfoBar';
import { ShipmentRow, DownloadButton, StyledButton } from 'components/Styled';
import FirstMileProvider from 'components/common/firstMileProvider';
import ImagePlane from 'assets/images/plane-black.svg';
import ImagePrinter from 'assets/images/printer.png';
import ImagePrinter2x from 'assets/images/printer@2x.png';
import ImagePrinter3x from 'assets/images/printer@3x.png';
import Hints from 'assets/images/hints.svg';

import { getOrderRequest } from 'ducks/shipments';

// import PaperlessEnvelope from 'assets/images/paperless/envelope.svg.js';
// import PaperlessSmallParcel from 'assets/images/paperless/small-parcel.svg.js';
// import PaperlessBox from 'assets/images/paperless/box.svg.js';
// import PaperlessLuggage from 'assets/images/paperless/luggage.svg.js';
// import PaperlessBoxes from 'assets/images/paperless/boxes.svg.js';
// import boxes from 'data/boxes';

import countries from 'data/countries';

class Finish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originExpand: false,
      destinationExpand: false,
      uiLoaded: false
    };

    this.price = new currency(props?.shipmentData?.totalRate)
      .subtract(new currency(props?.discount || 0))
      .add(new currency(props?.pickupData?.pickupFee || 0));
  }

  handleOriginExpand = () => {
    this.setState({
      originExpand: !this.state.originExpand
    });
  };

  handleDestinationExpand = () => {
    this.setState({
      destinationExpand: !this.state.destinationExpand
    });
  };

  handleClick = () => {
    window.dataLayer.push({ event: 'Download Waybill', ecommerce: undefined });
    window.open(get(this.props.shipmentData, 'labelUrl'));
  };

  handleConfirmClick = () => {
    this.props.determineBusinessOrPersonal(0);
  };

  componentDidMount() {
    window.dataLayer.push({
      event: 'Land Thank You Page',
      ecommerce: undefined,
      trackingNumber: this.props.trackingNumber
    });
    localStorage.removeItem('campaign');
    this.props.handler.openPopup(filter(this.props.posts, ['page', 'FINISH']));

    const params = queryString.parse(this.props.location.search);
    // check for redirect back to finish page
    if (params.orderref && localStorage.getItem(`order-${params.orderref}`)) {
      const params = queryString.parse(this.props.location.search);
      let local;
      let data;
      let props;
      try {
        // get state
        local =
          JSON.parse(localStorage.getItem(`order-${params.orderref}`)) || {};
        // get data for completeShipment
        data =
          JSON.parse(localStorage.getItem(`order-${params.orderref}-data`)) ||
          {};
        props =
          JSON.parse(localStorage.getItem(`order-${params.orderref}-props`)) ||
          {};

        this.props.handler.restoreOrderState({ local, data, props });
        return this.props.getOrderRequest({
          orderRef: params.orderref
        });
      } catch (e) {
        console.error(e);
      }
    }

    if (this.props.redirect) {
      this.props.history.replace(
        `${process.env.PUBLIC_URL}/create-shipment/quotation`
      ); // redirect to step 1 from direct url
      return null;
    }

    this.setState({ uiLoaded: true });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // check for redirect back to finish page
    if (!prevProps.getOrderSuccess && this.props.getOrderSuccess) {
      if (this.props.paymentStatus !== 'PAID') {
        this.props.history.replace(
          `${process.env.PUBLIC_URL}/create-shipment/quotation`
        ); // redirect to step 1 from direct url
        return null;
      }

      this.setState({ uiLoaded: true });
    }
  }

  render() {
    if (!this.state.uiLoaded) return null;

    const minDatetime = moment(
      get(this.props.pickupData, 'minDatetime')
    ).utcOffset(process.env.REACT_APP_SERVER_UTC_OFFSET);
    const maxDatetime = moment(
      get(this.props.pickupData, 'maxDatetime')
    ).utcOffset(process.env.REACT_APP_SERVER_UTC_OFFSET);

    const countriesData = keyBy(this.props.countries, 'alpha-2');

    if (!this.props.shipmentData) return null;
    const lang = localStorage.i18nextLng;

    return (
      <div
        className="quotation-content"
        style={{
          paddingBottom: '25px',
          margin: '0 auto',
          overflowX: 'hidden',
          width: '100%',
          maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
        }}>
        <div
          style={{
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
            padding: '25px 0'
          }}>
          <div
            className="success-msg buttonTheme-color"
            style={{
              fontSize: '24px',
              fontWeight: 700,
              textAlign: 'center',
              color: '#57D7DD'
            }}>
            {this.props.t('finish.success_booking')}
          </div>
          <div style={{ paddingTop: '22px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px' }}>
              <div style={{ display: 'inline-block', paddingRight: '10px' }}>
                {helpers.responsiveImage(
                  helpers.getCarrierImage(this.props.carrier),
                  helpers.getCarrierText(this.props.carrier),
                  helpers.getCarrierImageWidth(this.props.carrier, 0.8)
                )}
              </div>
              <span style={{ verticalAlign: 'middle' }}>
                {this.props.carrierService.name[this.props.t('key')]}
              </span>
            </div>
            <div
              style={{
                fontSize: '20px',
                fontWeight: 700,
                padding: '7px 0 5px'
              }}>
              {get(
                countriesData[this.props.origin],
                `name.${this.props.t('key')}`
              )}
              <img
                src={ImagePlane}
                style={{
                  width: '31.3px',
                  paddingBottom: '2px',
                  margin: '0 6px'
                }}
                alt=""
              />
              {get(
                countriesData[this.props.destination],
                `name.${this.props.t('key')}`
              )}
            </div>
            <div>
              <div style={{ fontSize: '12px' }}>
                {this.props.t('finish.tracking_link')}
                <a
                  className="buttonTheme-color"
                  style={{ color: '#9900A5' }}
                  href={helpers.getCarrierTrackingUrl(
                    get(this.props.shipmentData, 'carrierService.carrier'),
                    this.props.trackingNumber
                  )}
                  target="_blank"
                  rel="noopener noreferrer">
                  {this.props.trackingNumber}{' '}
                  <FontAwesomeIcon icon="angle-right" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {get(this.props.shipmentData, 'isPaperless') &&
        get(this.props.pickupData, 'type') !== 'SELF_PICKUP' ? (
          <div style={{ padding: '30px 15px', textAlign: 'center' }}>
            <div style={{ fontWeight: 700, fontSize: '20px' }}>
              {this.props.t('finish.paperless.write_pickup_number')}
            </div>

            <div style={{ paddingTop: '10px' }}>
              {this.props.pickupData.firstMileProvider &&
                this.props.pickupData.firstMileProvider.slug && (
                  <FirstMileProvider
                    slug={this.props.pickupData.firstMileProvider.slug}
                    boxStyles={{ fontSize: '12px', paddingBottom: '3px' }}
                  />
                )}

              {this.props.t('finish.paperless.attention')}
              <span className="buttonSecond-color" style={{ color: '#9900A5' }}>
                {this.props.t('finish.paperless.refuse_to')}
              </span>
              {this.props.t('finish.paperless.parcel_with_no_pickup_number')}
            </div>

            <div
              className="buttonTheme-color"
              style={{
                fontSize: '42px',
                fontWeight: '700',
                color: '#9900A5',
                border: '1px solid #d9dfec',
                padding: '15px 10px',
                margin: '25px 0'
              }}>
              {get(this.props.pickupData, 'pickupNumber')}
            </div>
            <div style={{ padding: '25px 0 43px' }}>
              <span style={{ display: 'inline-block' }}>
                <img
                  style={{ width: '50%' }}
                  src={this.props.paperlessImageUrl}
                  alt=""
                />
                {/*image is 2x*/}
              </span>
            </div>
          </div>
        ) : (
          <div style={{ padding: '30px 15px', textAlign: 'center' }}>
            <div style={{ fontWeight: 700, fontSize: '20px' }}>
              {get(this.props.pickupData, 'type') !== 'SELF_PICKUP'
                ? this.props.t('finish.download_print_invoice')
                : this.props.t('finish.drop_off.title')}
            </div>
            {get(this.props.pickupData, 'type') !== 'SELF_PICKUP' ? (
              <div style={{ fontSize: '12px', paddingTop: '10px' }}>
                {this.props.t('finish.receive')}
                <span
                  className="buttonSecond-color"
                  style={{ color: '#9900A5' }}>
                  {this.props.t('finish.required')}
                </span>
                {this.props.t('finish.pass_to_delivery')}
              </div>
            ) : (
              <div
                style={{ fontSize: '12px', paddingTop: '10px' }}
                dangerouslySetInnerHTML={{
                  __html: this.props.t('finish.drop_off.content', {
                    carrier: helpers.getCarrierText(this.props.carrier)
                  })
                }}
              />
            )}
            <div style={{ padding: '25px 0 43px' }}>
              {helpers.responsiveImage({
                '1x': ImagePrinter,
                '2x': ImagePrinter2x,
                '3x': ImagePrinter3x
              })}
            </div>
            <div>
              <InfoBar
                containerStyle={{
                  textAlign: 'left',
                  marginLeft: -20,
                  marginRight: -20,
                  backgroundColor: 'white'
                }}
                title={{ __html: this.props.t('finish.drop_off.hints.title') }}
                content={{
                  __html: this.props.t('finish.drop_off.hints.content', {
                    carrier: helpers.getCarrierText(this.props.carrier)
                  })
                }}
              />
              <div
                className="buttonTheme-color"
                style={{
                  color: '#9900A5',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  fontSize: '12px'
                }}>
                <a
                  className="buttonTheme-color"
                  href={
                    'https://spaceship.crisp.help/zh-hk/article/5aac5l2v6acq57se5ae5lu2-fa6cn0/'
                  }
                  target="_blank"
                  rel="noopener noreferrer">
                  {this.props.t('finish.drop_off.url', {
                    carrier: helpers.getCarrierText(this.props.carrier)
                  })}{' '}
                  <FontAwesomeIcon icon="external-link-alt" />
                </a>
              </div>
              <br />
            </div>
            <DownloadButton
              onClick={this.handleClick}
              type="primary"
              block
              style={{ margin: '10px 0 30px' }}>
              <FontAwesomeIcon icon="external-link-alt" />
              <span style={{ paddingLeft: '5px' }}>
                {this.props.t('finish.download_label')}
              </span>
            </DownloadButton>
          </div>
        )}
        <div style={{ padding: '0 15px' }}>
          <div
            style={{
              fontWeight: 700,
              fontSize: '20px',
              paddingBottom: '15px'
            }}>
            {this.props.t('finish.booking_detail')}
          </div>
          <div
            style={{
              padding: '20px 0',
              borderTop: '1px solid #d9dfec',
              borderBottom: '1px solid #d9dfec'
            }}>
            {get(this.props.pickupData, 'type') === 'NORMAL' && (
              <ShipmentRow type="flex" align="top">
                <Col span={10}>
                  {get(
                    countriesData[this.props.origin],
                    `name.${this.props.t('key')}`
                  )}
                  {this.props.t('payment.pickup_time')}
                </Col>
                <Col span={14} style={{ textAlign: 'left' }}>
                  {minDatetime.format('D MMM')} ({minDatetime.format('h:mm a')}{' '}
                  - {maxDatetime.format('h:mm a')})
                </Col>
              </ShipmentRow>
            )}
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.pickup_number')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.pickupData, 'pickupNumber') || 'N/A'}{' '}
                {get(this.props.pickupData, 'type') === 'NORMAL' &&
                  get(this.props.shipmentData, 'carrierService.csUrl') && (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="buttonTheme-color"
                      style={{ color: '#9900A5' }}
                      href={get(
                        this.props.shipmentData,
                        'carrierService.csUrl'
                      )}>
                      {this.props.t('transactions.pickupHotline', {
                        carrier: get(
                          this.props.shipmentData,
                          'carrierService.carrierName.en'
                        )
                      })}{' '}
                      <FontAwesomeIcon icon="external-link-alt" />
                    </a>
                  )}
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                <ExpandButton
                  expand={this.state.originExpand}
                  onClick={this.handleOriginExpand}
                />
                {this.props.t(
                  `payment.${
                    get(this.props.pickupData, 'type') === 'SELF_PICKUP'
                      ? 'post'
                      : 'pickup'
                  }_address`
                )}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                <AddressCard
                  t={this.props.t}
                  country={this.props.origin}
                  address={this.props.shipmentData.fromAddress}
                  expand={this.state.originExpand}
                />
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                <ExpandButton
                  expand={this.state.destinationExpand}
                  onClick={this.handleDestinationExpand}
                />
                {this.props.t('payment.receiver_address')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                <AddressCard
                  t={this.props.t}
                  country={this.props.destination}
                  address={this.props.shipmentData.toAddress}
                  expand={this.state.destinationExpand}
                />
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t('payment.expected_arrived_date')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {(() => {
                  const deliveryDate = get(
                    this.props.shipmentData,
                    'deliveryDate'
                  );
                  const minDeliveryDays = get(
                    this.props.shipmentData,
                    'minDeliveryDays'
                  );
                  const maxDeliveryDays = get(
                    this.props.shipmentData,
                    'maxDeliveryDays'
                  );

                  if (deliveryDate) {
                    return moment
                      .tz(
                        get(this.props.shipmentData, 'deliveryDate'),
                        get(countriesData[this.props.destination], 'zone-name')
                      )
                      .format('D MMM h:mm a z');
                  }

                  if (minDeliveryDays && maxDeliveryDays) {
                    if (minDeliveryDays === maxDeliveryDays) {
                      return `${minDeliveryDays} ${this.props.t(
                        'common.working_day'
                      )}`;
                    }

                    return `${minDeliveryDays} - ${maxDeliveryDays} ${this.props.t(
                      'common.working_day'
                    )}`;
                  }

                  return this.props.t('common.cant_provide');
                })()}
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.total_quantity')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {this.props.t('payment.box', {
                  amount: get(this.props.boxData, 'totalBox')
                })}
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t('payment.estimated_total_weight')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.boxData, 'totalWeight')} kg
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.estimated_weight')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.boxData, 'totalVolumeWeight')} kg
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>
                {this.props.t('payment.estimated_pay_weight')}
              </Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {get(this.props.boxData, 'previewWeight')} kg
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.received_order_at')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {moment(this.props.orderCreatedAt).format('D MMM h:mm a')}
              </Col>
            </ShipmentRow>
            <ShipmentRow type="flex" align="top">
              <Col span={10}>{this.props.t('payment.paid')}</Col>
              <Col span={14} style={{ textAlign: 'left' }}>
                {this.price.format()}
              </Col>
            </ShipmentRow>
            {this.props.memberRef && (
              <ShipmentRow type="flex" align="top">
                <Col span={10}>{this.props.t('payment.partner')}</Col>
                <Col span={14} style={{ textAlign: 'left' }}>
                  {this.props.campaignData.name[lang]} ({' '}
                  {this.props.memberRef.slice(0, 4)} ******* )
                </Col>
              </ShipmentRow>
            )}
          </div>
          {this.props.origin !== 'HK' && (
            <div
              style={{
                color: '#2C2C2E',
                fontSize: '12px',
                paddingTop: '25px',
                textAlign: 'left'
              }}>
              <img
                src={Hints}
                style={{ height: 14, marginRight: 2, marginBottom: 5 }}
                alt=""
              />
              <span
                style={{
                  color: '#2C2C2E',
                  fontSize: 14,
                  lineHeight: '16px',
                  fontWeight: 700
                }}>
                {this.props.t('transactions.dropoffTitle')}
              </span>
              <br />
              {this.props
                .t('transactions.dropoff', {
                  carrier: get(
                    this.props.shipmentData,
                    `carrierService.carrierName.${this.props.t('key')}`
                  ),
                  returnObjects: true
                })
                .map((y, j) => (
                  <span key={j}>
                    {j !== 0 && <br />}
                    <span
                      key={`service_text_${j}`}
                      style={{ fontSize: 12, lineHeight: '18px' }}>
                      {y}
                    </span>
                    {j === 2 && (
                      <span
                        style={{
                          color: '#9900A5',
                          fontWeight: 700,
                          cursor: 'pointer'
                        }}
                        onClick={() => {}}>
                        {this.props.t('transactions.cs')}{' '}
                        <FontAwesomeIcon icon="angle-right" />
                      </span>
                    )}
                  </span>
                ))}
            </div>
          )}
          {get(this.props.shipmentData, 'isPaperless') &&
          get(this.props.pickupData, 'type') !== 'SELF_PICKUP' ? (
            <>
              <div
                style={{
                  color: '#2C2C2E',
                  fontSize: '12px',
                  paddingTop: '25px',
                  textAlign: 'left'
                }}>
                <img
                  src={Hints}
                  style={{ height: 14, marginRight: 2, marginBottom: 5 }}
                  alt=""
                />
                <span
                  style={{
                    color: '#2C2C2E',
                    fontSize: 14,
                    lineHeight: '16px',
                    fontWeight: 700
                  }}>
                  {this.props.t('finish.paperless.pickup_preparation')}
                </span>
                <div style={{ paddingTop: '10px', color: '#2C2C2E' }}>
                  <div>
                    {this.props.t('finish.paperless.hints_line_1_1')}
                    <span style={{ fontWeight: 700 }}>
                      {this.props.t('finish.paperless.hints_line_1_2')}
                      <span
                        className="buttonTheme-color"
                        style={{ color: '#9900A5' }}>
                        {get(this.props.pickupData, 'pickupNumber')}
                      </span>
                      {this.props.t('finish.paperless.hints_line_1_3')}
                    </span>
                  </div>
                  <div style={{ padding: '8px 0' }}>
                    {this.props.t('finish.paperless.hints_line_2_1')}
                    <span style={{ fontWeight: 700 }}>
                      {this.props.t('finish.paperless.hints_line_2_2')}
                    </span>
                    {this.props.t('finish.paperless.hints_line_2_3')}
                  </div>
                  <div>
                    {this.props.t('finish.paperless.hints_line_3')}
                    <br />
                  </div>
                </div>
              </div>
              <div>
                <div style={{ padding: '25px 0 35px', textAlign: 'center' }}>
                  <StyledButton
                    onClick={this.handleClick}
                    type="primary"
                    block
                    style={{ marginBottom: '20px' }}>
                    <FontAwesomeIcon icon="external-link-alt" />
                    <span style={{ paddingLeft: '5px' }}>
                      {this.props.t('finish.download_label')}
                    </span>
                  </StyledButton>
                  <StyledButton
                    type="primary"
                    block
                    ghost
                    onClick={this.handleConfirmClick}>
                    {this.props.t('button.confirm')}
                  </StyledButton>
                </div>
              </div>
            </>
          ) : (
            <div>
              <div style={{ padding: '35px 0', textAlign: 'center' }}>
                <StyledButton
                  type="primary"
                  ghost
                  onClick={this.handleConfirmClick}
                  htmlType="submit">
                  {this.props.t('button.confirm')}
                </StyledButton>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getOrderRequest
};

const mapStateToProps = state => {
  const obj = {};
  const arr = state.campaigns.availableCampaigns || [];
  arr.forEach(c => (obj[c.campaignSlug] = c));

  const campaignSlug =
    get(state.campaigns.campaignData, 'campaignSlug') ||
    localStorage.campaign ||
    'asiamiles';
  const campaignData = obj[campaignSlug];

  return {
    rates: state.shipments.rates || [],
    posts: state.shipments.posts || false,
    countries: state.shipments.countries || countries,
    campaignData,
    memberRef: state.campaigns.memberRef,
    paymentMethodData: state.shipments.paymentMethodData || {},
    pickupData: state.shipments.pickupData,
    orderCreatedAt: state.shipments.orderCreatedAt,
    shipmentData: state.shipments.shipmentData,
    paymentStatus: state.shipments.paymentStatus || '',
    getOrderSuccess: !!state.shipments.getOrderSuccess
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Finish))
);
